import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from './assets/hzh_logo.png';
const _hoisted_1 = {
  key: 0,
  class: "footer"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "苏州清澈水湾蟹业有限公司 版权所有 ", -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "address"
}, "地址：苏州市相城区太平街道旺巷村(渔业)", -1);

const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), $setup.useRoute().name != 'scanCodePage' ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5)) : _createCommentVNode("", true)], 64);
}